import { Component, Input, OnInit, inject } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppointmentRoom, StudySpacesService } from '../study-spaces.service';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { ComponentsModule } from 'src/app/components/components.module';
import { RoomTimetablePage } from '../room-timetable/room-timetable.page';

@Component({
  selector: 'app-study-areas-study-spaces-room-selection',
  templateUrl: './room-selection.component.html',
  styleUrls: ['./room-selection.component.scss'],
  imports: [
    IonicModule,
    TranslatePipe,
    RouterModule,
    ComponentsModule
]
})
export class RoomSelectionComponent  implements OnInit {
  private studySpacesService = inject(StudySpacesService);
  private activatedRoute = inject(ActivatedRoute);
  modalController = inject(ModalController);
  translate = inject(TranslateService);

  public rooms: AppointmentRoom[] = [];

  @Input()
  public buildingId: number | string;

  ngOnInit() {
    let buildingIdParam = this.buildingId ?? this.activatedRoute.snapshot.paramMap.get('buildingId');
    let buildingId: number | null = buildingIdParam as number;
    
    if(buildingIdParam && typeof buildingIdParam !== 'number') {
      if(typeof buildingIdParam == 'string') {
        buildingId = Number.parseInt(buildingIdParam);
      } else {
        buildingId = null;
      }
    }
    this.studySpacesService.getRoomsByBuilding(buildingId).subscribe((rooms: AppointmentRoom[]) => {
      this.rooms = rooms;
    })
  }

  public async openTimetable(buildingId: number | string, roomId: number) {
    const modal = await this.modalController.create({
      component: RoomTimetablePage,
      presentingElement: await this.modalController.getTop(),
      componentProps: {
        buildingId,
        roomId
      }
    });
    modal.present();
  }
}
